import React from "react";
import Navigation from "../../components/Navigation/Navigation"

const Contact = ()=>{
    return(
        <div className="Contact">
            <Navigation page="Contact"/>
            <h1>Contact</h1>
        </div>
    )
}

export default Contact;